import { useNavigate } from "react-router-dom";
import styles from "./Banner.module.css"


function Banner({ videoSrc, title, subtitle }){
    const navigate = useNavigate()

    function pagContact() {
        navigate("/contact");
    }

    return(
        <section className={styles.banner}>
        <div className={styles.structure}>

            <video src={videoSrc} autoPlay loop muted playsInline/>
            
            <div className={styles.colorVideo} ></div>
            <div className={styles.img}></div>

            <div className={styles.content}>
                <h1 dangerouslySetInnerHTML={{__html: title}}></h1>
                <p dangerouslySetInnerHTML={{__html: subtitle}}></p>
                <button onClick={pagContact}>Get in Touch</button>
            </div>
        </div>
        </section>
    )
}

export default Banner
